import {
  Stat,
  StatLabel,
  StatHelpText,
  Flex,
  Text,
  Box,
  CircularProgress,
  CircularProgressLabel,
} from "@chakra-ui/react";

const StatCircle = ({
  label,
  description,
  number,
  helpNumber,
  helpText,
  helpColor,
  ml,
}: {
  label: string;
  description: string;
  number: number;
  helpNumber: number | string;
  helpText: string;
  helpColor: string;
  ml?: string;
}) => {
  return (
    <Stat flex="1" ml={ml}>
      <Flex w="100%" alignItems="center">
        <Box flex="1">
          <StatLabel fontSize="20px">{label}</StatLabel>
          <Text fontWeight="500" fontSize="17px" mb="5px" mt="20px">
            {description}
          </Text>
          <StatHelpText>
            <Text
              display="inline"
              color={helpColor}
              fontWeight="500"
              fontSize="17px"
            >
              {helpNumber}
            </Text>{" "}
            {helpText}
          </StatHelpText>
        </Box>
        <CircularProgress
          h="100%"
          value={number}
          color="primary"
          thickness="6px"
          size="80px"
        >
          <CircularProgressLabel fontWeight="700" fontSize="18px">
            {number}%
          </CircularProgressLabel>
        </CircularProgress>
      </Flex>
    </Stat>
  );
};

export default StatCircle;
